<template>
  <div class="page">
    <!-- 头部 -->
    <div class="page-header">
      <el-divider content-position="left"
        >内保单号（{{ formData.bill_data.bh || insBillId }}）</el-divider
      >
    </div>
    <!-- 基本信息 -->
    <BaseInfo
      :infoOptions="detailBaseInfoOption"
      :infoData="formData.bill_data"
    />

    <!-- 车辆信息 -->
    <el-tabs class="card-info shadow" type="border-card">
      <el-tab-pane label="车辆信息">
        <BaseInfo
          labelWidth="120"
          :infoOptions="detailCarInfoOption"
          :infoData="formData.car_data"
        />
      </el-tab-pane>
      <el-tab-pane label="关系人信息">
        <FoldedPanel>
          <template #title>被内保人</template>
          <BaseInfo
            :infoOptions="detailPersonInfoOption"
            :infoData="formData.person_data[0]"
          />
        </FoldedPanel>
        <FoldedPanel>
          <template #title>参保人</template>
          <BaseInfo
            :infoOptions="detailPersonInfoOption"
            :infoData="formData.person_data[1]"
          />
        </FoldedPanel>
        <FoldedPanel>
          <template #title>车主</template>
          <BaseInfo
            :infoOptions="detailPersonInfoOption"
            :infoData="formData.person_data[2]"
          />
        </FoldedPanel>
      </el-tab-pane>
      <el-tab-pane label="内保明细">
        <FoldedPanel>
          <template #title>
            <span class="panel-header-text"
              ><i class="icon el-icon-menu">主内保类型</i></span
            >
          </template>
          <el-table :data="majorData" style="width: 100%">
            <!-- <el-table-column prop="isCheck" label="选择" width="80">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.isCheck" @change="(val) => detailTtemChange(scope.row, 'isCheck')"></el-checkbox>
              </template>
            </el-table-column> -->
            <el-table-column prop="name" min-width="200" label="项目">
              <template slot-scope="scope">
                <div v-if="scope.row.type_id === 4 || scope.row.type_id === 8">
                  <span v-if="!scope.row.isCheck"
                    >{{ scope.row.name }}{{ scope.row.special_fee }}元/座
                    <span>
                      共{{
                        formData.car_data.passengerCount - 1 > 0
                          ? formData.car_data.passengerCount - 1
                          : 0
                      }}座</span
                    ></span
                  >

                  <div class="input-wrap" v-if="scope.row.isCheck">
                    {{ scope.row.name }}
                    <el-select
                      v-model="scope.row.special_fee"
                      filterable
                      placeholder="万元"
                      @change="
                        (val) => detailTtemChange(scope.row, 'special_fee')
                      "
                    >
                      <el-option
                        v-for="item in $emun.seatOption"
                        :key="item.label"
                        :value="item.value"
                        :label="item.label"
                      ></el-option>
                    </el-select>
                    <span
                      >共{{
                        formData.car_data.passengerCount - 1 > 0
                          ? formData.car_data.passengerCount - 1
                          : 0
                      }}座</span
                    >
                  </div>
                </div>
                <div v-else-if="scope.row.type_id === 1">
                  <span v-if="!scope.row.isCheck">{{
                    `${scope.row.name}  绝对免赔额 ${scope.row.special_fee}`
                  }}</span>
                  <div class="input-wrap" v-if="scope.row.isCheck">
                    {{ `${scope.row.name}  绝对免赔额` }}
                    <el-input
                      v-if="scope.row.type_id === 1"
                      v-model="scope.row.special_fee"
                      placeholder="元"
                      @change="
                        (val) => detailTtemChange(scope.row, 'special_fee')
                      "
                    ></el-input>
                  </div>
                </div>
                <div v-else>
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="tcfee" label="内保额(元)">
              <template slot-scope="scope">
                <div v-if="scope.row.type_id === 4 || scope.row.type_id === 8">
                  {{
                    (
                      scope.row.special_fee *
                      (formData.car_data.passengerCount - 1 > 0
                        ? formData.car_data.passengerCount - 1
                        : 0)
                    ).toFixed(2)
                  }}元
                </div>
                <div v-else>
                  <span v-if="!scope.row.isCheck"
                    >{{ (scope.row.tcfee * 1).toFixed(2) }}元</span
                  >
                  <div class="input-wrap" v-if="scope.row.isCheck">
                    <div
                      v-if="scope.row.type_id === 2 || scope.row.type_id === 6"
                    >
                      <el-autocomplete
                        class="inline-input"
                        v-model="scope.row.tcfee"
                        :fetch-suggestions="querySearch"
                        placeholder="请输入内容"
                        @select="handleSelect"
                      >
                        <template slot-scope="{ item }">
                          <div>{{ item.label }}</div>
                        </template>
                      </el-autocomplete>
                    </div>
                    <el-input
                      v-else
                      v-model="scope.row.tcfee"
                      placeholder="元"
                      @change="(val) => detailTtemChange(scope.row, 'tcfee')"
                    ></el-input>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="bztcfee" label="标准内保费(元)">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck"
                  >{{ (scope.row.bztcfee * 1).toFixed(2) }}元</span
                >
                <div class="input-wrap" v-if="scope.row.isCheck">
                  <el-input
                    v-model="scope.row.bztcfee"
                    placeholder="元"
                    @change="(val) => detailTtemChange(scope.row, 'bztcfee')"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="discount" label="折扣">
              <template slot-scope>
                {{ formData.bill_data.cusRebate }}
              </template>
            </el-table-column>
            <el-table-column prop="yjtcfee" label="应交内保费(元)">
              <template slot-scope="scope">
                {{
                  (formData.bill_data.cusRebate * scope.row.bztcfee).toFixed(2)
                }}
              </template>
            </el-table-column>
          </el-table>
        </FoldedPanel>
        <!-- <div class="flex mb15">
          <div></div>
          <el-button type="primary" @click="handleStandard">获取标费</el-button>
        </div> -->
        <FoldedPanel>
          <template #title>
            <span class="panel-header-text"
              ><i class="icon el-icon-menu">附加内保类型</i></span
            >
          </template>
          <el-table :data="additionData" style="width: 100%">
            <!-- <el-table-column prop="isCheck" label="选择" width="80">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.isCheck" @change="(val) => detailTtemChange(scope.row, 'isCheck')"></el-checkbox>
              </template>
            </el-table-column> -->
            <el-table-column prop="name" min-width="200" label="项目">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck">{{ scope.row.name }}</span>
                <div class="input-wrap" v-if="scope.row.isCheck">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="tcfee" label="内保额(元)">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck"
                  >{{ (scope.row.tcfee * 1).toFixed(2) }}元</span
                >
                <div class="input-wrap" v-if="scope.row.isCheck">
                  <el-input
                    v-model="scope.row.tcfee"
                    placeholder="元"
                    @change="(val) => detailTtemChange(scope.row, 'tcfee')"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="bztcfee" label="标准内保费(元)">
              <template slot-scope="scope">
                <span v-if="!scope.row.isCheck"
                  >{{ (scope.row.bztcfee * 1).toFixed(2) }}元</span
                >
                <div class="input-wrap" v-if="scope.row.isCheck">
                  <el-input
                    v-model="scope.row.bztcfee"
                    placeholder="元"
                    @change="(val) => detailTtemChange(scope.row, 'bztcfee')"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="discount" label="折扣">
              <template slot-scope>
                {{ formData.bill_data.cusRebate }}
              </template>
            </el-table-column>
            <el-table-column prop="yjtcfee" label="应交内保费(元)">
              <template slot-scope="scope">
                {{ (scope.row.yjtcfee * 1).toFixed(2) }}
              </template>
            </el-table-column>
          </el-table>
        </FoldedPanel>
        <div class="panel-detail-footer">
          <div class="panel-detail-footer-left">
            <div class="label">
              整单折扣：{{ formData.bill_data.cusRebate }}
            </div>
          </div>
          <div class="panel-detail-footer-right">
            <span class="mr15">标准内保费合计：{{ standardTotal }}元</span>
            <span>应交内保费合计：{{ practicalTotal }}元</span>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="附件">
        <FoldedPanel v-for="item in encList" :key="item.title">
          <template #title
            ><div class="enc">
              <div class="encTitle">
                <i class="el-icon-info"></i>
                <span>{{ item.title }}</span>
              </div>
              <div class="encNum">
                <span>{{ item.fileList.length }}/{{ item.max }}</span>
                张文件
              </div>
            </div></template
          >
          <div class="img-box">
            <template slot="header"> </template>
            <div class="img-list">
              <el-upload
                action=""
                :auto-upload="false"
                name="img"
                multiple
                list-type="picture-card"
                :file-list="item.fileList"
                :limit="item.max"
                :on-change="(file) => handleChangeFile(file, item)"
                :on-preview="handlePictureCardPreview"
                :on-remove="
                  (file, fileList) => handleRemoveImg(file, fileList, item)
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="preVisible">
                <img width="100%" :src="preImageUrl" alt="" />
              </el-dialog>
            </div>
            <div>
              <el-button type="primary" @click="saveEnc(item)" v-if="isSupplement">保存</el-button>
            </div>
          </div>
        </FoldedPanel>
      </el-tab-pane>
      <el-tab-pane label="特别约定">
        {{ formData.bill_data.specialRemark }}
      </el-tab-pane>
      <el-tab-pane label="日志信息">
        <el-steps direction="vertical">
          <el-step v-for="log in logs" :key="log.id">
            <template #title>{{ log.operate_time }}</template>
            <template #description>
              <span>{{ log.user_name }}：</span>
              <span>{{ log.operate_content }}</span>
            </template>
          </el-step>
        </el-steps>
      </el-tab-pane>
      <el-tab-pane label="备注">
        {{ formData.bill_data.remark }}
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";

import {
  detailBaseInfoOption,
  detailCarInfoOption,
  detailPersonInfoOption,
} from "./formOptions";
export default {
  name: "Recording",
  comments: {},
  data() {
    return {
      standardTotal: 0,
      practicalTotal: 0,
	  isSupplement: false, // 是否附件补录
      formData: {
        //主要信息
        bill_data: {},
        //车辆信息
        car_data: {
          passengerCount: 0,
        },
        //人员关系信息
        person_data: [
          {
            personType: 0,
            isgroup: 0,
          },
          {
            personType: 1,
            isgroup: 0,
          },
          {
            personType: 2,
            isgroup: 0,
          },
        ],
        //附件信息
        enc_data: [],
        //内保详细信息
        detail_data: {},
      },
      logs: [], // 日志信息
      // 主内保类型
      majorData: [],
      // 附加内保列表
      additionData: [],
      // 附件回显相关
      identityPhoto: [],
      drivingPhoto: [],
      businessPhoto: [],
      paymentPhoto: [],
      validatePhoto: [],
      standardPhoto: [],
      otherPhoto: [],
      dangerNum: [],
      preImageUrl: "",
      preVisible: false,
    };
  },
  computed: {
    detailBaseInfoOption,
    detailCarInfoOption,
    detailPersonInfoOption,
    collapseList() {
      return [
        {
          title: "被内保人",
          key: 0,
        },
        {
          title: "参保人",
          key: 1,
        },
        {
          title: "车主",
          key: 2,
        },
      ];
    },
    encList() {
      //附件
      return [
        {
          title: "身份证",
          imageType: 1,
          max: 5,
          fileList: this.identityPhoto,
          prop: "identityPhoto",
        },
        {
          title: "行驶证",
          imageType: 2,
          max: 5,
          fileList: this.drivingPhoto,
          prop: "drivingPhoto",
        },
        {
          title: "出险次数截图",
          imageType: 7,
          max: 5,
          fileList: this.dangerNum,
          prop: "dangerNum",
        },
        {
          title: "支付凭证截图",
          imageType: 8,
          max: 5,
          fileList: this.paymentPhoto,
          prop: "paymentPhoto",
          thumbnail:
            "https://longfei-billing.oss-cn-beijing.aliyuncs.com/admin/item/20220113/44dddf01e40f0c98a46a6a7256cb84ef.jpeg",
        },
        {
          title: "营业执照",
          imageType: 3,
          max: 5,
          fileList: this.businessPhoto,
          prop: "businessPhoto",
        },
        {
          title: "验车照片",
          imageType: 4,
          max: 5,
          fileList: this.validatePhoto,
          prop: "validatePhoto",
        },
        {
          title: "标准费用参考图",
          imageType: 5,
          max: 5,
          fileList: this.standardPhoto,
          prop: "standardPhoto",
        },
        {
          title: "其他",
          imageType: 6,
          max: 8,
          fileList: this.otherPhoto,
          prop: "otherPhoto",
        },
      ];
    },
  },
  created() {
    this.handleSearh();
  },
  methods: {
    getToken,
    // 回显详情
    async handleSearh() {
      const { insBillId } = this.$route.query;
	  const { supplement } = this.$route.query;
	 if(supplement){
		 this.isSupplement = true;
	 }

      this.insBillId = insBillId;
      // const res = await this.$api.post("/admin/insbill/getDetailByBid", {
      //   insBillId,
      // });
      const res = await this.$api.post("/admin/insbill/getTheDetail", {
        keyword: insBillId,
      });
      console.log(res.data.base);
      // 回显基本信息
      const billData = {
        ...res.data.base,
        days: this.$tools.getDaysBetween(
          res.data.base.beginTime,
          res.data.base.endTime
        ),
      };
      // 回显车辆信息
      const carData = {
        ...res.data.car,
      };
      // 回显关系人信息
      const personData = [
        ...res.data.person.map((item) => ({
          ...item,
          isgroup: item.isgroup ? "团队" : "个人",
        })),
      ];

      // 回显附件信息
      res.data.enc.forEach((ele) => {
        if (ele.imageType === 1) {
          this.identityPhoto.push(ele);
        }
        if (ele.imageType === 2) {
          this.drivingPhoto.push(ele);
        }
        if (ele.imageType === 3) {
          this.businessPhoto.push(ele);
        }
        if (ele.imageType === 4) {
          this.validatePhoto.push(ele);
        }
        if (ele.imageType === 5) {
          this.standardPhoto.push(ele);
        }
        if (ele.imageType === 6) {
          this.otherPhoto.push(ele);
        }
        if (ele.imageType === 7) {
          this.dangerNum.push(ele);
        }
        if (ele.imageType === 8) {
          this.paymentPhoto.push(ele);
        }
      });
      res.data.item.forEach((element) => {
        if (element.type_pid === 0) {
          this.majorData.push(element);
        } else {
          this.additionData.push(element);
        }
      });
      this.standardTotal = res.data.base.contractFee || 0;
      this.practicalTotal = res.data.base.cusFee || 0;

      // 回显日志信息
      this.logs = res.data.log;

      console.log(this.majorData);
      this.formData = {
        bill_data: {
          ...billData,
        },
        //车辆信息
        car_data: {
          passengerCount: 0,
          ...carData,
          accidentCount: res.data.base.accidentCount,
          insYears: res.data.base.insYears,
        },
        //人员关系信息
        person_data: [...personData],
        //附件信息
        enc_data: [],
        //内保详细信息
        detail_data: {},
        // 特别约定
        template_data: {
          templateContent: "",
        },
        // car_data: res.data.car,
        // bill_data: res.data.base,
      };
      // this.formData.bill_data
      console.log(res);
    },

    async handleChangeFile(file, item) {
      this.loading = true;
      const fd = new FormData();

      fd.append("img", file.raw);
      fd.append("path", "20");
      const res = await this.$api.upload("/admin/upload/upimg", fd);
      if (res.code === 10000) {
        this.$message.success("上传成功");
        this[item.prop].push({
          imageType: item.imageType,
          url: res.data.path,
        });
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },

    // 预览图片
    handlePictureCardPreview(file) {
      console.log(file);
      this.preImageUrl = file.url;
      this.preVisible = true;
    },
    // 删除图片
    handleRemoveImg(res, fileList, item) {
      this[item.prop] = this[item.prop].filter((el) => el.url !== res.url);
    },

    // 保存附件
    async saveEnc(item) {
      const { insBillId } = this;
      let image = "";
      this[item.prop].forEach((item, index) => {
        image += index === 0 ? item.url : `,${item.url}`;
      });
      const encData = {
        insBillId: insBillId,
        type: item.imageType,
        image: image,
      };
      const res = await this.$api.post("/admin/insbill/saveEnc", encData);
      if (res.code == 10000) {
        this.$message.success("保存成功");
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>
<style>
.page {
  width: 100%;
  height: 100%;
  padding: 15px;
  .page-header {
    width: 100%;
    display: flex;
    align-items: center;
    .header-inner {
      width: 40%;
      display: flex;
      align-items: center;
      .content {
        flex: 1;
      }
    }
  }

  .img-box {
    padding: 15px 0;
    display: flex;
    justify-content: space-between;
    .img-box-item {
      margin-left: 15px;
      border-radius: 4px;
    }
  }
}
.panel-detail-footer {
  display: flex;
  margin-top: 15px;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  .panel-detail-footer-left {
    display: flex;
    align-items: center;
    .label {
      white-space: nowrap;
    }
  }
}
/deep/.el-step__icon {
  border: 1px solid !important;
}
/deep/.el-icon-circle-close {
  color: #ef6027 !important;
}
// 附件标题
.enc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .encTitle {
    & > span {
      margin-left: 15px;
      font-size: 16px;
      color: #666;
    }
  }
  .encNum {
    font-size: 14px;
    color: #666;
    & > span {
      color: red;
      margin-right: 4px;
    }
  }
  .drawer-content {
    width: 100%;
    height: 100%;
  }
}
</style>
